import { datadogRum } from '@datadog/browser-rum';
export default function () {
  try {
    let env = 'local';
    if (document.location.host.includes('usafacts.org')) {
      switch (document.location.host.split('.')[0]) {
        case undefined:
        case 'usafacts':
          env = 'prod';
          break;
        case 'qa':
          env = 'qa';
          break;
        case 'dev':
          env = 'dev';
          break;
        default:
          break;
      }
    }
    console.log('Initializing Datadog RUM');
    datadogRum.init({
      applicationId: '40640911-97cd-4290-a5a1-172ee43312c7',
      clientToken: 'pubcd5f59dd0508f5b9a2ecf45026e27d35',
      site: 'us5.datadoghq.com',
      service: 'frontend-website-cms',
      env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: env === 'prod' ? 3 : 100,
      trackInteractions: env !== 'prod'
    });
  } catch (e) {
    console.error('Unable to start Datadog RUM', e);
  }
}